<mat-toolbar *ngIf="isAdmin$ | async" class="mat__config-toolbar mat-toolbar-single-row">
    <div class="nav__container">
        <div class="nav__container__left-section">
            <button mat-button class="nav__container__left-section-config" (click)="onConfigure.emit(true)">{{configurationName}}</button>
        </div>
    </div>
</mat-toolbar>